#import "../fragments/notify-message-fragment.graphql"

mutation DismissNotifyMessage($input: NotifyMessageDismissInput!) {
    notifyMessageDismiss(input: $input) {
        loggedInUser {
            id
            notifies {
                ...NotifyMessageFragment
            }
        }
    }
}
